import { functions } from '.';

export async function getRoles() {
  const getRolesCall = functions.httpsCallable('adminRolesGet');
  const roles = await getRolesCall();
  return roles.data;
}

export async function assignRoles(userId, roles) {
  const assignRolesCall = functions.httpsCallable('adminRolesUpdate');
  await assignRolesCall({ userId, roles });
}

export default {
  assignRoles,
  getRoles
};
